import React from "react";

import { Container, Typography, Grid, Link } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiscord, faTwitch } from "@fortawesome/free-brands-svg-icons";

import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  BCPEnvelope,
  BCPFacebook,
  BCPInstagram,
  BCPReorder,
  BCPThreads,
  BCPTwitterX,
  BCPYoutube
} from "../icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const getSocials = () => {
  let socials = {};
  if (
    getEnvironmentVariable("SOCIALS") !== undefined &&
    getEnvironmentVariable("SOCIALS") !== "NOT SET"
  ) {
    try {
      socials = JSON.parse(getEnvironmentVariable("SOCIALS"));
    } catch (err) {}
  }
  return socials;
};

const useStyles = makeStyles((theme) => ({
  heading: {
    width: "100%",
    textAlign: "center",
    display: "flex",
    flexFirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  socialButton: {
    "&:hover": {
      color: theme?.palette?.primary?.light,
      backgroundColor: theme?.palette?.primary?.main
        ? alpha(theme?.palette?.primary?.main, 0.09)
        : null
    }
  }
}));

export default function SocialsGroup(props) {
  const classes = useStyles();
  return (
    <>
      {props.title && props.title !== "" && (
        <Typography
          className={classes.heading}
          gutterBottom
          variant={
            props.titleSize && props.titleSize !== "" ? props.titleSize : "h4"
          }
          component="h2"
        >
          {props.title}
        </Typography>
      )}
      <Container maxWidth="md">
        <Grid container spacing={3} justifyContent="center">
          {getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={`mailto:${getEnvironmentVariable(
                  "COMPANY_SUPPORT_EMAIL"
                )}`}
                aria-label="Company Support Email"
              >
                <BCPEnvelope sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().socials && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().socials}
                target="_Blank"
                aria-label="Company social media accounts"
              >
                <BCPReorder sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().facebook && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().facebook}
                target="_Blank"
                aria-label="Company's Facebook account"
              >
                <BCPFacebook sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().twitter && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().twitter}
                target="_Blank"
                aria-label="Company's X/Twitter account"
              >
                <BCPTwitterX sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().instagram && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().instagram}
                target="_Blank"
                aria-label="Company's Instagram account"
              >
                <BCPInstagram sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().discord && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().discord}
                target="_Blank"
                aria-label="Company's Discord server"
              >
                <FontAwesomeIcon icon={faDiscord} />
              </Link>
            </Grid>
          )}
          {getSocials().twitch && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().twitch}
                target="_Blank"
                aria-label="Company's Twitch account"
              >
                <FontAwesomeIcon icon={faTwitch} />
              </Link>
            </Grid>
          )}
          {getSocials().youtube && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().youtube}
                target="_Blank"
                aria-label="Company's Youtube account"
              >
                <BCPYoutube sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
          {getSocials().threads && (
            <Grid item>
              <Link
                color="inherit"
                underline="none"
                href={getSocials().threads}
                target="_Blank"
                aria-label="Company's Threads account"
              >
                <BCPThreads sx={{ fontSize: "inherit", width: "inherit" }} />
              </Link>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
